import React from 'react'

import { faFileExport } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CSVLink } from 'react-csv'
import { useTranslation } from 'react-i18next'

const CsvExportButton = ({ data, headers, filename, buttonText }: any) => {
  const { t } = useTranslation()
  return (
    // @ts-ignore
    <CSVLink
      data={data || ''}
      headers={headers}
      filename={filename}
      className={`p-1.5 rounded-md border text-center border-primary text-primary`}
    >
      {t(buttonText)} <FontAwesomeIcon icon={faFileExport} />
    </CSVLink>
  )
}

export default CsvExportButton
